import { Loader2, ShieldCheck } from "lucide-react";
import { PhonePeBadge } from "./RailSelector";

const RazorpayMark = ({ size = 14 }) => (
  <span aria-hidden className="inline-flex items-center justify-center rounded-[3px] bg-[#0C2451] text-white font-black leading-none select-none"
        style={{ width: size, height: size, fontSize: Math.round(size * 0.7) }}>R</span>
);

/**
 * Two explicit customer-facing rails — always both, never one.
 * onPay(rail) receives "razorpay" | "phonepe". `busy` can be false | "razorpay" | "phonepe" | true.
 */
export function PayRailButtons({ onPay, busy = false, amountLabel = "", disabled = false, testId = "pay-rail", className = "", compact = false, note }) {
  const isBusy = (r) => busy === true || busy === r;
  const anyBusy = !!busy;
  const base = `w-full inline-flex items-center justify-center gap-2.5 rounded-sm font-grotesk uppercase tracking-[0.24em] transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${compact ? "px-4 py-2.5 text-[10px]" : "px-5 py-3.5 text-[11px]"}`;
  return (
    <div data-testid={testId} className={`space-y-2.5 ${className}`}>
      <button type="button" data-testid={`${testId}-razorpay`} onClick={() => onPay("razorpay")} disabled={disabled || anyBusy}
              className={`${base} bg-[#D8B23E] text-black hover:bg-[#E5C450] hover:-translate-y-px shadow-[0_8px_30px_-12px_rgba(216,178,62,0.6)]`}>
        {isBusy("razorpay") ? <Loader2 size={13} className="animate-spin" /> : <RazorpayMark size={13} />}
        Pay via Razorpay{amountLabel ? ` · ${amountLabel}` : ""}
      </button>
      <button type="button" data-testid={`${testId}-phonepe`} onClick={() => onPay("phonepe")} disabled={disabled || anyBusy}
              className={`${base} bg-[#5F259F] text-white hover:bg-[#6E2FB8] hover:-translate-y-px shadow-[0_8px_30px_-12px_rgba(95,37,159,0.7)]`}>
        {isBusy("phonepe") ? <Loader2 size={13} className="animate-spin" /> : <PhonePeBadge size={13} />}
        Pay via PhonePe{amountLabel ? ` · ${amountLabel}` : ""}
      </button>
      <p data-testid={`${testId}-note`} className="flex items-start gap-1.5 text-[10px] leading-relaxed text-[#8A8A82] font-body">
        <ShieldCheck size={11} className="shrink-0 mt-0.5 text-[#D8B23E]" />
        <span>{note || "Choose either rail — UPI, cards and net-banking on both. Razorpay and PhonePe are both live for Vinci Inc. collections."}</span>
      </p>
    </div>
  );
}

export const withRail = (path, rail) => `${path}${path.includes("?") ? "&" : "?"}rail=${rail}`;
